<template lang="html">

  <section class="home-empresa row-between container ais">

    <div class="contenedor-left">

      <div class="contenedor-home container row-between ais">
        <!-- <article class="home-el">
          <div>
            <h3>PRÁCTICAS PARA ESTUDIANTES</h3>
            <p>Ofertas para incorporar estudiantes de la Universidad de León mediante Convenios de Colaboración Educativa entre empresa y Universidad. </p>
            <p>Si ya conoces al estudiante que va a realizar la práctica. Haz tu propuesta de prácticas para el estudiante <router-link to="/propuesta-practicas">aquí</router-link>.</p>
          </div>
          <div class="container-btns">
            <div class="grid">
              <router-link to="/nueva-oferta/practicas" class="btn-link">Nueva oferta</router-link>
            </div>
            <div class="grid column-between">
              <p class="mb-0"><strong>{{procesosPracticasEstudiantesActivos.length}} Oferta<template v-if="procesosPracticasEstudiantesActivos.length > 1">s</template> de prácticas</strong></p>
              <router-link to="/mis-ofertas/practicas" class="w-100" >Gestiona tus ofertas</router-link>
            </div>
          </div>
        </article> -->
        <!-- OCULTAMOS DE MOMENTO EN PROD -->
        <article class="home-el">
          <div>
            <h3>AGENCIA DE EMPLEO</h3>
            <p>Ofertas para incorporar demandantes de empleo y promover la integración laboral de personas desempleadas, el desarrollo profesional de trabajadores en activo y la dinamización del mercado de trabajo.</p>
          </div>
          <div class="container-btns">
            <div class="grid">
              <router-link to="/nueva-oferta/empleo" class="btn-link">Nueva oferta</router-link>
            </div>
            <div class="grid column-between">
              <p class="mb-0"><strong>{{procesosEmpleoActivos.length}} Oferta<template v-if="procesosEmpleoActivos.length > 1 || procesosEmpleoActivos.length == 0">s</template> publicada<template v-if="procesosEmpleoActivos.length > 1 || procesosEmpleoActivos.length == 0">s</template></strong></p>
              <router-link to="/mis-ofertas/empleo" class="w-100" >Gestiona tus ofertas</router-link>
            </div>
          </div>
        </article>
        <article class="home-el">
          <div>
            <h3>PRÁCTICAS PARA TITULADOS</h3>
            <p>Ofertas para Titulados Universitarios, de Formación Profesional y de Enseñanzas Escolares de Régimen Especial para complementar su formación académica realizando prácticas formativas en entidades, públicas o privadas.</p>
          </div>
          <router-link to="/programas-practicas-activos" class="link-arrow-color">
            Consultar programas de prácticas y sus condiciones
          </router-link>
          <div class="container-btns">
            <div class="grid">
              <router-link to="/nueva-oferta/practicastitulados" class="btn-link">Nueva oferta</router-link>
            </div>
            <div class="grid column-between">
              <p class="mb-0"><strong>{{procesosPracticasTituladosActivos.length}} Oferta<template v-if="procesosPracticasTituladosActivos.length > 1">s</template> de prácticas</strong></p>
              <router-link to="/mis-ofertas/practicastitulados" class="w-100" >Gestiona tus ofertas</router-link>
            </div>
          </div>
        </article>

        <div class="contenedor-modulo-comunicaciones" v-if="comunicaciones.length > 0">
        <modulo-comunicaciones ></modulo-comunicaciones>
        </div>
      </div>


      <div class="contenedor-encuestas">
        <modulo-encuestas></modulo-encuestas>
      </div>

     
    </div>


  </section>

</template>

<script lang="js">

  import {mapGetters, mapActions} from 'vuex';

  import moduloEncuestas from '@/components/views/home/modulo-encuestas'

  import moduloComunicaciones from './modulo-comunicaciones';
  import moduloProgramas from './modulo-programas';

  export default  {
    name: 'home-empresa',
    mounted(){
      this.requestProcesos();
    },
    components :{
      'modulo-encuestas' : moduloEncuestas,
      'modulo-comunicaciones' : moduloComunicaciones,
      'modulo-programas' : moduloProgramas,
    },
    methods : {
      ...mapActions(['requestProcesos']),
    },
    computed : {
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        procesos : 'getProcesos',
        procesosEmpleo : 'getProcesosEmpleo',
        procesosPracticasTitulados: 'getProcesosPracticasTitulados',
        procesosPracticasEstudiantes:'getProcesosPracticasEstudiantes',
        comunicaciones : 'getComunicaciones',
        brand : 'getBrand'
      }),
      procesosPracticasTituladosActivos : function(){
        let procesos = new Array();
        if(!!this.procesosPracticasTitulados){
          procesos = this.procesosPracticasTitulados.filter(p => p.idEstado == 2)
        }
        return procesos;
      },
      procesosPracticasEstudiantesActivos : function(){
        let procesos = new Array();
        if(!!this.procesosPracticasEstudiantes){
          procesos = this.procesosPracticasEstudiantes.filter(p => p.idEstado == 2)
        }
        return procesos;
      },
      procesosEmpleoActivos : function(){
        let procesos = new Array();
        if(!!this.procesosEmpleo){
          procesos = this.procesosEmpleo.filter(p => p.idEstado == 2)
        }
        return procesos;
      }
    }
  }
</script>

<style scoped lang="scss">


@import '@/assets/css/colors.scss';

  .home-empresa{
    max-width: 1200px;
    padding-top: 70px;
    min-height: calc(100vh - 309px);
  }

  .contenedor-home{
    padding-bottom:20px;
    max-width: 960px;
  }

  .home-el  {
    width: calc(50% - 10px);
    padding: 25px;
    margin-bottom: 50px;
    text-align: left;
    position: relative;
    font-size: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p{
      font-size: 15px;
    }
    &:nth-child(3){
      margin-bottom: 0;
    }

    &:nth-child(4){
      margin-bottom: 0;
    }
    .container-btns{
      margin-top: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .grid{
        width:48%;
        &.column-between{
          *{
            text-align: right;
          }
          a{
            color: var(--app-color);
            text-decoration: underline;
          }
        }
      }
      strong{
        font-weight: bold;
      }
    }
    

  }

  .home-el h3{
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 600;
  }

  .home-el h3 strong{
    width: 100%;
    display: inline-block;
    font-size: 24px;
    font-weight: 800;
  }

  .bubble{
    position: absolute;
    right: 20px;
    top: 0;
    transform: translateY(-50%);
    height: 55px;
    line-height: 55px;
    width: 55px;
    font-weight: 800;
    text-align: center;
    font-size: 21px;
    border-radius: 100%;
  }

  .bubble.add{
    font-size: 36px;
  }

  .container.-comunicaciones{
    width: auto;
  }

  .contenedor-left:first-child:last-child{
    width: 100%;
  }

  @media screen and (max-width: 1185px){
    .home-empresa{
      justify-content: center;
      -webkit-justify-content: center;
    }

    .contenedor-modulo-comunicaciones{
      max-width: 768px;
      padding-bottom: 50px;
    }
  }
 @media screen and (max-width: 820px){
  .home-el .container-btns .grid[data-v-6a2992ca] {
    width: 100%;
    margin-top: 20px;
  }
  .home-el .container-btns .grid.column-between *[data-v-6a2992ca] {
      text-align: left;
  }
  .home-el .container-btns{
    margin-top: 0;
  }
 }
  @media screen and (max-width: 767px){

    .contenedor-home{
      padding-top: 0px;
      padding-bottom: 25px;
    }

    .home-el{
      max-width: 100%;
      width: 100%;
      &:nth-child(3){
        margin-bottom: 50px;
      }
      &:last-of-type{
        margin-bottom: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/home/home-empresa.vue